(() => {
  // Namespace
  window.WOXI = window.WOXI || {};

  /* ----------------- Utils ----------------- */
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const CART_ICON_SELECTORS = [
    '.header__icon--cart',
    '.site-header__cart',
    'a[href$="/cart"]',
    'a[href*="/cart"]',
    'button[aria-controls="CartDrawer"]',
    '[data-cart-toggle]'
  ];
  const PRODUCT_FORM_SELECTOR = 'form[action*="/cart/add"], product-form form';

  function findCartIcon(root=document){
    for (const s of CART_ICON_SELECTORS){ const el = $(s, root); if (el) return el; }
    return null;
  }
  function ensureBadge(container){
    let badge = $('.woxi-cart-badge', container);
    if (!badge){
      badge = document.createElement('span');
      badge.className = 'woxi-cart-badge hidden';
      container.appendChild(badge);
    }
    return badge;
  }
  async function getCart(){
    try {
      const r = await fetch('/cart.js', { credentials:'same-origin', headers:{'Accept':'application/json'} });
      if (!r.ok) throw 0;
      return await r.json();
    } catch { return null; }
  }

  /* ----------------- UI updates ----------------- */
  async function updateCartUI({ triggerAttention=false } = {}){
    const icon = findCartIcon(); if (!icon) return;
    icon.classList.add('woxi-cart-colored'); // pinta morado coherente

    const badge = ensureBadge(icon);
    const cart  = await getCart(); if (!cart) return;

    const count = cart.item_count || 0;
    badge.textContent = count;
    badge.classList.toggle('hidden', count === 0);
    icon.classList.toggle('woxi-cart-has-items', count > 0);

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

    if (triggerAttention && count > 0) {
      icon.classList.add('woxi-cart-attn');
      setTimeout(() => icon.classList.remove('woxi-cart-attn'), 1800);
    }

    // Actualiza FAB también
    updateFab({ count, triggerBreath: triggerAttention });
  }

  /* ----------------- FAB flotante ----------------- */
  function ensureFab(){
    let fab = $('#woxi-cart-fab');
    if (fab) return fab;
    fab = document.createElement('button');
    fab.id = 'woxi-cart-fab';
    fab.type = 'button';
    fab.setAttribute('aria-label', 'Abrir carrito');
    fab.innerHTML = `
      <span class="woxi-badge">0</span>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4h-3"/><path d="M5 4l1.2 7.2a2 2 0 0 0 2 1.8h7.9a2 2 0 0 0 1.9-1.4l2-6.1H6.2"/><circle cx="9" cy="20" r="1.6"/><circle cx="17" cy="20" r="1.6"/></svg>
    `;
    document.body.appendChild(fab);

    fab.addEventListener('click', (e) => {
      e.preventDefault();
      const toggle = findCartIcon();
      if (toggle) {
        // intenta abrir drawer si lo hay
        toggle.dispatchEvent(new MouseEvent('click', { bubbles:true }));
      } else {
        location.href = '/cart';
      }
    });
    return fab;
  }

  // Estado header visible/oculto
  let isHeaderHidden = false;
  function observeHeader(){
    const header = $('header, .header, .header-wrapper, header[role="banner"]') || $('header');
    if (!header) {
      const onScroll = () => { isHeaderHidden = window.scrollY > 120; };
      window.addEventListener('scroll', onScroll, { passive:true });
      onScroll();
      return;
    }
    const io = new IntersectionObserver((entries)=>{
      const e = entries[0];
      isHeaderHidden = !(e && e.isIntersecting);
    }, { rootMargin:'0px', threshold:[0,0.01] });
    io.observe(header);
  }

  async function updateFab({ count, triggerBreath }){
    const fab = ensureFab();
    $('.woxi-badge', fab).textContent = count;
    fab.dataset.count = String(count || 0);

    const canShow = isHeaderHidden && (count||0) > 0;
    fab.classList.toggle('woxi-show', canShow);
    fab.classList.toggle('woxi-breathe', canShow && triggerBreath);
  }

  /* ----------------- Add to cart por AJAX ----------------- */
  function formToParams(form){
    const fd = new FormData(form);
    const p  = new URLSearchParams();
    for (const [k,v] of fd.entries()) if (v !== '' && v != null) p.append(k, v);
    return p;
  }

  async function handleAdd(form){
    if (form.__woxiBusy) return; form.__woxiBusy = true;
    const btn = $('button[name="add"], .product-form__submit, #ProductSubmitButton, [id^="ProductSubmitButton-"]', form) || $('button, input[type="submit"]', form);
    if (btn){
      (btn.querySelector('span') || btn).textContent = 'Comprar';
      btn.setAttribute('aria-label','Comprar'); btn.setAttribute('title','Comprar');
      if (btn.tagName === 'INPUT') btn.value = 'Comprar';
      if (matchMedia('(max-width:768px)').matches) btn.classList.add('woxi-cta-mobile');
      btn.classList.add('woxi-adding');
    }

    const params = formToParams(form);
    if (!params.has('id')) {
      const vid = $('[name="id"]', form)?.value || $('select[name="id"]', form)?.value;
      if (vid) params.set('id', vid);
    }
    if (!params.has('quantity')) {
      params.set('quantity', $('[name="quantity"]', form)?.value || 1);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8', 'Accept':'application/json' },
        body:params, credentials:'same-origin'
      });
      if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        throw new Error(err?.description || 'No se pudo agregar al carrito');
      }
      const added = await res.json();
      // Compatibilidad con upsell
      if (window.Shopify?.onItemAdded) try{ window.Shopify.onItemAdded(added); }catch{}
      document.dispatchEvent(new CustomEvent('woxi:added', { detail:{ item: added }}));
      await updateCartUI({ triggerAttention:true });
    } catch (e) {
      console.error('[woxi] add error', e);
      alert(e.message || 'No se pudo agregar al carrito');
    } finally {
      if (btn) btn.classList.remove('woxi-adding');
      form.__woxiBusy = false;
    }
  }

  function isProductForm(el){
    return !!el && (el.matches?.(PRODUCT_FORM_SELECTOR) || el.closest?.(PRODUCT_FORM_SELECTOR));
  }

  // Captura click y submit ANTES que el tema (sin tocar fetch)
  document.addEventListener('click', (ev)=>{
    const btn = ev.target.closest?.('button[name="add"], .product-form__submit, #ProductSubmitButton, [id^="ProductSubmitButton-"], input[type="submit"][name="add"]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!isProductForm(form)) return;
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    handleAdd(form);
  }, true);

  document.addEventListener('submit', (ev)=>{
    const form = ev.target;
    if (!isProductForm(form)) return;
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    handleAdd(form);
  }, true);

  // Boot
  function boot(){
    observeHeader();
    updateCartUI({ triggerAttention:false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Al volver de background, re-sync
  document.addEventListener('visibilitychange', ()=>{ if (!document.hidden) updateCartUI(); });

})();
(() => {
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
  const ICON_CONTAINERS = ['.header__icon--cart', '.site-header__cart', 'a[href*="/cart"]'];

  function findIconContainer(){
    for (const sel of ICON_CONTAINERS){ const el = $(sel); if (el) return el; }
    return null;
  }

  // Usa la burbuja del tema si existe; si no, crea una nuestra
  function ensureSingleBadge(container){
    const themeBadge = container.querySelector('.cart-count-bubble, [data-cart-count]');
    if (themeBadge){
      // aplica tamaño pequeño y elimina nuestras antiguas si las hay
      themeBadge.classList.add('woxi-badge-tiny');
      container.querySelectorAll('.woxi-cart-badge').forEach(n => n.remove());
      return themeBadge;
    }
    let badge = container.querySelector('.woxi-cart-badge');
    if (!badge){
      badge = document.createElement('span');
      badge.className = 'woxi-cart-badge woxi-badge-tiny';
      container.appendChild(badge);
    }
    return badge;
  }

  async function getCart(){
    try{
      const r = await fetch('/cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}});
      if (!r.ok) throw 0;
      return await r.json();
    }catch{ return null; }
  }

  async function syncCartBadge(){
    const container = findIconContainer();
    if (!container) return;

    const badge = ensureSingleBadge(container);
    const cart  = await getCart(); if (!cart) return;

    const count = cart.item_count || 0;
    const target = badge.firstElementChild || badge; // algunos temas meten un span
    target.textContent = count;

    // Mostrar/ocultar acorde al conteo
    badge.classList.toggle('hidden', count === 0);
  }

  // 1) Al cargar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartBadge);
  } else {
    syncCartBadge();
  }

  // 2) Cuando otras partes de tu sitio disparen estos eventos
  document.addEventListener('cart:updated', syncCartBadge);
  document.addEventListener('woxi:added',  syncCartBadge);

  // 3) Al volver de background
  document.addEventListener('visibilitychange', () => { if (!document.hidden) syncCartBadge(); });

  // 4) Opcional: re-sincroniza si alguien usa fetch a /cart/add (sin romper nada)
  if (!window.__woxiPatchedFetch) {
    const _fetch = window.fetch;
    window.fetch = function(i, init){
      const p = _fetch.apply(this, arguments);
      p.then(() => {
        try{
          const url = typeof i === 'string' ? i : i?.url;
          if (url && url.indexOf('/cart/add') !== -1) setTimeout(syncCartBadge, 120);
        }catch{}
      });
      return p;
    };
    window.__woxiPatchedFetch = true;
  }
})();
